module.exports = __webpack_public_path__ + "scripts/flags.png?9c74e172";


//////////////////
// WEBPACK FOOTER
// ./semantic/dist/themes/default/assets/images/flags.png
// module id = 1485
// module chunks = 1